import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ModulosGrupos from "./componentes/tabla_modulos"

const Modulos = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                borderRadius="lg"
                coloredShadow="info"
                sx={{
                  background: "linear-gradient(45deg, #e60000, #ff3300)",
                  color: "white",
                }}
              >
                <MDTypography variant="h6" color="white">
                  Gestión de Capacitaciones
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                {/* Aquí irán los componentes como tablas, formularios o modales de módulos */}
                <ModulosGrupos/>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default Modulos;
